import { render, staticRenderFns } from "./ManageRawBag.vue?vue&type=template&id=25e5cff4&scoped=true"
import script from "./ManageRawBag.vue?vue&type=script&lang=js"
export * from "./ManageRawBag.vue?vue&type=script&lang=js"
import style0 from "./ManageRawBag.vue?vue&type=style&index=0&id=25e5cff4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25e5cff4",
  null
  
)

export default component.exports